import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as settings from "../../../constants/settings";
import * as config from "../../../constants/config";
import * as handlers from "../../../constants/handlers";
import * as resources from "../../../constants/resources";
import * as navigationActions from "../../../actions/navigationActions";
import * as settingsActions from "../../../actions/settingsActions";
import * as globalActions from "../../../actions/globalActions";
import * as windowService from "../../../services/windowService";
import * as validationHelper from "../../../helpers/validationHelper";
import * as translationHelper from "../../../helpers/translationHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import imgConfirm from "../../../resources/img/svgicons/confirm.svg";

import CancelButton from "../generic/CancelButton";
import Modal from "../generic/Modal";
import Button from "../generic/Button";
import Input from "../generic/Input";

class FileTransferTaskModal extends Component {
    constructor(props) {
        super(props);

        this.state = this.getInitialState(props);
    }

    getInitialState = (props) => {
        let initialState = {
            type: settings.FILE_TRANSFER_IN_TASK,
            key: null,
            name: "",
            interval: 10,
            intervalHours: "0",
            intervalMinutes: "0",
            intervalSeconds: "10",
            format: settings.OPTION_NONE,
            protocol: settings.OPTION_NONE,
            protocolOptions: [],
            protocolFolderPath: "",
            protocolHost: "",
            protocolPort: "",
            protocolUsername: "",
            protocolPassword: "",
            protocolRemoteFolder: "",
            protocolDirection: settings.OPTION_NONE,
            notification: settings.OPTION_NONE,
            startType: settings.START_TYPE_AUTO,
            alreadyExists: false,
            isValid: false
        };

        if (props.params === undefined || props.params === null) {
            return initialState;
        }

        if (props.params.type !== undefined) {
            initialState.type = props.params.type;
        }

        if (props.params.task === undefined || props.params.task === null) {
            return initialState;
        }

        let protocol = this.getProtocolByType(props.params.task.protocol);
        let protocolOptions = props.params.task.protocolOptions;

        initialState.key = props.params.task.getKey();
        initialState.name = props.params.task.name === null ? "" : props.params.task.name;
        initialState.format = props.params.task.format;
        initialState.protocol = props.params.task.protocol;
        initialState.protocolOptions = protocol === null ? [] : protocol.options;
        initialState.protocolFolderPath = protocolOptions.folder_path === undefined ? "" : protocolOptions.folder_path;
        initialState.protocolHost = protocolOptions.host === undefined ? "" : protocolOptions.host;
        initialState.protocolPort = protocolOptions.port === undefined ? "" : String(protocolOptions.port);
        initialState.protocolUsername = protocolOptions.username === undefined ? "" : protocolOptions.username;
        initialState.protocolPassword = protocolOptions.password === undefined ? "" : protocolOptions.password;
        initialState.protocolRemoteFolder = protocolOptions.folder === undefined ? "" : protocolOptions.folder;
        initialState.protocolDirection =
            protocolOptions.direction === undefined ? settings.OPTION_NONE : protocolOptions.direction;
        initialState.isValid = true;

        if (initialState.type === settings.FILE_TRANSFER_IN_TASK) {
            initialState.interval = props.params.task.interval;
            initialState.intervalHours = String(props.params.task.intervalHours);
            initialState.intervalMinutes = String(props.params.task.intervalMinutes);
            initialState.intervalSeconds = String(props.params.task.intervalSeconds);
            initialState.notification =
                props.params.task.notification === null ? settings.OPTION_NONE : props.params.task.notification;
        }

        if (initialState.type === settings.FILE_TRANSFER_OUT_TASK) {
            initialState.startType = props.params.task.startType;
        }

        return initialState;
    };

    getProtocolByType = (type) => {
        for (let protocol of this.props.protocolList) {
            if (protocol.type === type) {
                return protocol;
            }
        }

        return null;
    };

    getProtocolOptions = () => {
        let protocolOptions = {};

        for (let option of this.state.protocolOptions) {
            switch (option.key) {
                case "folder_path":
                    protocolOptions["folder_path"] = this.state.protocolFolderPath.trim();
                    break;
                case "host":
                    protocolOptions["host"] = this.state.protocolHost.trim();
                    break;
                case "port":
                    protocolOptions["port"] = Number(this.state.protocolPort);
                    break;
                case "username":
                    protocolOptions["username"] = this.state.protocolUsername.trim();
                    break;
                case "password":
                    protocolOptions["password"] = this.state.protocolPassword.trim();
                    break;
                case "folder":
                    protocolOptions["folder"] = this.state.protocolRemoteFolder.trim();
                    break;
                case "direction":
                    protocolOptions["direction"] =
                        this.state.protocolDirection === settings.OPTION_NONE ? null : this.state.protocolDirection;
                    break;
                default:
                    break;
            }
        }

        return protocolOptions;
    };

    getProtocolTestOptions = () => {
        let protocolOptions = {};

        for (let option of this.state.protocolOptions) {
            switch (option.key) {
                case "host":
                    protocolOptions["host"] = this.state.protocolHost.trim();
                    break;
                case "port":
                    protocolOptions["port"] = Number(this.state.protocolPort);
                    break;
                case "username":
                    protocolOptions["username"] = this.state.protocolUsername.trim();
                    break;
                case "password":
                    protocolOptions["password"] = this.state.protocolPassword.trim();
                    break;
                case "folder":
                    protocolOptions["folder"] = this.state.protocolRemoteFolder.trim();
                    break;
                case "direction":
                    protocolOptions["direction"] =
                        this.state.protocolDirection === settings.OPTION_NONE ? null : this.state.protocolDirection;
                    break;
                default:
                    break;
            }
        }

        return protocolOptions;
    };

    getFormatOptions = () => {
        return {};
    };

    isValid = () => {
        if (
            this.state.protocol === settings.OPTION_NONE ||
            this.state.format === settings.OPTION_NONE ||
            this.state.name.trim().length === 0
        ) {
            return false;
        }

        if (this.state.type === settings.FILE_TRANSFER_IN_TASK && this.state.interval === 0) {
            return false;
        }

        for (let option of this.state.protocolOptions) {
            switch (option.key) {
                case "folder_path":
                    if (this.state.protocolFolderPath.trim().length === 0) {
                        return false;
                    }
                    break;
                case "host":
                    if (this.state.protocolHost.trim().length === 0) {
                        return false;
                    }
                    break;
                case "port":
                    if (
                        this.state.protocolPort.trim().length === 0 ||
                        !validationHelper.isPortValid(Number(this.state.protocolPort))
                    ) {
                        return false;
                    }
                    break;
                case "username":
                    if (this.state.protocolUsername.trim().length === 0) {
                        return false;
                    }
                    break;
                case "password":
                    if (this.state.protocolPassword.trim().length === 0) {
                        return false;
                    }
                    break;
                case "folder":
                    if (this.state.protocolRemoteFolder.trim().length === 0) {
                        return false;
                    }
                    break;
                case "direction":
                    if (this.state.protocolDirection === settings.OPTION_NONE) {
                        return false;
                    }
                    break;
                default:
                    break;
            }
        }

        return true;
    };

    isAlreadyInTaskList = () => {
        if (this.state.type === settings.FILE_TRANSFER_OUT_TASK) {
            for (let task of this.props.taskOutList) {
                if (
                    task.getKey() !== this.state.key &&
                    task.compareTo(
                        this.state.format,
                        this.state.protocol,
                        this.state.protocolFolderPath,
                        this.state.protocolHost,
                        this.state.protocolPort,
                        this.state.protocolRemoteFolder
                    )
                ) {
                    return true;
                }
            }

            return false;
        }

        for (let task of this.props.taskInList) {
            if (
                task.getKey() !== this.state.key &&
                task.compareTo(
                    this.state.format,
                    this.state.protocol,
                    this.state.protocolFolderPath,
                    this.state.protocolHost,
                    this.state.protocolPort,
                    this.state.protocolRemoteFolder
                )
            ) {
                return true;
            }
        }

        return false;
    };

    validateForm = () => {
        this.setState({
            isValid: this.isValid(),
            alreadyExists: this.isAlreadyInTaskList()
        });
    };

    addTask = () => {
        if (this.state.type === settings.FILE_TRANSFER_IN_TASK) {
            let newTaskInList = this.props.taskInList.map((task) => task.formatTask());

            let newInTask = modelHelper.mapFileTransferInTaskToObject(
                this.state.name,
                this.state.format,
                this.getFormatOptions(),
                this.state.protocol,
                this.getProtocolOptions(),
                this.state.interval,
                this.state.notification === settings.OPTION_NONE ? null : this.state.notification
            );

            if (newInTask !== null) {
                this.props.dispatchSetFileTransferInTasksAction([...newTaskInList, newInTask.formatTask()]);
            }
        } else if (this.state.type === settings.FILE_TRANSFER_OUT_TASK) {
            let newTaskOutList = this.props.taskOutList.map((task) => task.formatTask());

            let newOutTask = modelHelper.mapFileTransferOutTaskToObject(
                this.state.name,
                this.state.format,
                this.getFormatOptions(),
                this.state.protocol,
                this.getProtocolOptions(),
                this.state.startType
            );

            if (newOutTask !== null) {
                this.props.dispatchSetFileTransferOutTasksAction([...newTaskOutList, newOutTask.formatTask()]);
            }
        }
    };

    editTask = () => {
        if (this.state.type === settings.FILE_TRANSFER_IN_TASK) {
            let newTaskInList = this.props.taskInList.map((task) => {
                if (this.state.key === task.getKey()) {
                    let newTask = modelHelper.mapFileTransferInTaskToObject(
                        this.state.name,
                        this.state.format,
                        this.getFormatOptions(),
                        this.state.protocol,
                        this.getProtocolOptions(),
                        this.state.interval,
                        this.state.notification === settings.OPTION_NONE ? null : this.state.notification
                    );

                    if (newTask !== null) {
                        return newTask.formatTask();
                    }
                }

                return task.formatTask();
            });

            this.props.dispatchSetFileTransferInTasksAction(newTaskInList);
        } else if (this.state.type === settings.FILE_TRANSFER_OUT_TASK) {
            let newTaskOutList = this.props.taskOutList.map((task) => {
                if (this.state.key === task.getKey()) {
                    let newTask = modelHelper.mapFileTransferOutTaskToObject(
                        this.state.name,
                        this.state.format,
                        this.getFormatOptions(),
                        this.state.protocol,
                        this.getProtocolOptions(),
                        this.state.startType
                    );

                    if (newTask !== null) {
                        return newTask.formatTask();
                    }
                }

                return task.formatTask();
            });

            this.props.dispatchSetFileTransferOutTasksAction(newTaskOutList);
        }
    };

    calculateInterval = (hoursInput, minutesInput, secondsInput) => {
        let seconds = 0;

        if (hoursInput.trim().length > 0 && !isNaN(hoursInput)) {
            seconds += Number(hoursInput) * 60 * 60;
        }

        if (minutesInput.trim().length > 0 && !isNaN(minutesInput)) {
            seconds += Number(minutesInput) * 60;
        }

        if (secondsInput.trim().length > 0 && !isNaN(secondsInput)) {
            seconds += Number(secondsInput);
        }

        return seconds;
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleNameChange = (event) => {
        this.setState(
            {
                name: event.target.value
            },
            this.validateForm
        );
    };

    handleProtocolChange = (event) => {
        let protocol = this.getProtocolByType(event.target.value);

        this.setState(
            {
                protocol: event.target.value,
                protocolOptions: protocol === null ? [] : protocol.options
            },
            this.validateForm
        );
    };

    handleFormatChange = (event) => {
        this.setState(
            {
                format: event.target.value
            },
            this.validateForm
        );
    };

    handleIntervalHoursChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value) && Number(event.target.value) < 100) {
            this.setState(
                {
                    interval: this.calculateInterval(
                        event.target.value,
                        this.state.intervalMinutes,
                        this.state.intervalSeconds
                    ),
                    intervalHours: event.target.value.trim().length === 0 ? "" : String(Number(event.target.value))
                },
                this.validateForm
            );
        }
    };

    handleIntervalMinutesChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value) && Number(event.target.value) < 60) {
            this.setState(
                {
                    interval: this.calculateInterval(
                        this.state.intervalHours,
                        event.target.value,
                        this.state.intervalSeconds
                    ),
                    intervalMinutes: event.target.value.trim().length === 0 ? "" : String(Number(event.target.value))
                },
                this.validateForm
            );
        }
    };

    handleIntervalSecondsChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value) && Number(event.target.value) < 60) {
            this.setState(
                {
                    interval: this.calculateInterval(
                        this.state.intervalHours,
                        this.state.intervalMinutes,
                        event.target.value
                    ),
                    intervalSeconds: event.target.value.trim().length === 0 ? "" : String(Number(event.target.value))
                },
                this.validateForm
            );
        }
    };

    handleProtocolFolderPathChange = (event) => {
        this.setState(
            {
                protocolFolderPath: event.target.value
            },
            this.validateForm
        );
    };

    handleProtocolHostChange = (event) => {
        this.setState(
            {
                protocolHost: event.target.value
            },
            this.validateForm
        );
    };

    handleProtocolPortChange = (event) => {
        if (!isNaN(event.target.value) && validationHelper.isPortValid(Number(event.target.value))) {
            this.setState(
                {
                    protocolPort: event.target.value
                },
                this.validateForm
            );
        }
    };

    handleProtocolUsernameChange = (event) => {
        this.setState(
            {
                protocolUsername: event.target.value
            },
            this.validateForm
        );
    };

    handleProtocolPasswordChange = (event) => {
        this.setState(
            {
                protocolPassword: event.target.value
            },
            this.validateForm
        );
    };

    handleProtocolRemoteFolderChange = (event) => {
        this.setState(
            {
                protocolRemoteFolder: event.target.value
            },
            this.validateForm
        );
    };

    handleProtocolDirectionChange = (event) => {
        this.setState(
            {
                protocolDirection: event.target.value
            },
            this.validateForm
        );
    };

    handleNotificationChange = (event) => {
        this.setState(
            {
                notification: event.target.value
            },
            this.validateForm
        );
    };

    handleStartTypeChange = (event) => {
        this.setState(
            {
                startType: event.target.value
            },
            this.validateForm
        );
    };

    handleTestConnectionClick = () => {
        this.props.dispatchTestProtocolConnectionAction(this.state.protocol, this.getProtocolTestOptions());
    };

    handleConfirmClick = () => {
        if (this.state.key !== null) {
            this.editTask();
        } else {
            this.addTask();
        }

        this.props.dispatchCloseModalAction();
    };

    changeProtocolFolderPath = (path) => {
        this.setState(
            {
                protocolFolderPath: path
            },
            this.validateForm
        );
    };

    handleOpenProtocolFolderPathDialogClick = () => {
        windowService.openSelectDirectoryDialog(this.changeProtocolFolderPath);
    };

    getProtocolSelectBox = () => {
        let options = [];

        options.push(
            <option key={settings.OPTION_NONE} value={settings.OPTION_NONE}>
                -
            </option>
        );

        for (let protocol of this.props.protocolList) {
            options.push(
                <option key={protocol.type} value={protocol.type}>
                    {translationHelper.getProtocolTranslation(protocol.type, this.props.softwareName)}
                </option>
            );
        }

        return options;
    };

    getFormatTranslation = (format) => {
        switch (format.type) {
            case settings.DESO_CUSTOM_FORMULA_XML:
                return translate("general.customFormula") + " (" + format.filePattern + ")";
            case settings.DESO_CUSTOM_FORMULA_SIMPLE_XML:
                return translate("fileTransfer.customFormulaSimple") + " (" + format.filePattern + ")";
            case settings.DESO_CUSTOMER_XML:
                return translate("general.customer") + " (" + format.filePattern + ")";
            case settings.DESO_HISTORY_XML:
                return translate("navigation.menu.dispensingHistory") + " (" + format.filePattern + ")";
            case settings.DESO_ORDER_XML:
                return translate("mainTab.order") + " (" + format.filePattern + ")";
            default:
                return format.name;
        }
    };

    getFormatSelectBox = () => {
        let options = [];

        options.push(
            <option key={settings.OPTION_NONE} value={settings.OPTION_NONE}>
                -
            </option>
        );

        if (this.state.type === settings.FILE_TRANSFER_OUT_TASK) {
            for (let format of this.props.outFormatList) {
                if (format.type !== settings.DESO_ORDER_XML) {
                    options.push(
                        <option key={format.type} value={format.type}>
                            {this.getFormatTranslation(format)}
                        </option>
                    );
                }
            }

            return options;
        }

        for (let format of this.props.inFormatList) {
            options.push(
                <option key={format.type} value={format.type}>
                    {this.getFormatTranslation(format)}
                </option>
            );
        }

        return options;
    };

    getHelpButton = () => {
        if (this.props.loggedUser.canEdit(resources.FUNCTION_OPEN_BROWSER)) {
            return (
                <a
                    href={config.HELP_ON_REDLIKE_FILE_TRANSFER}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{textDecoration: "none"}}
                >
                    <Button label={<Translate value="help.help" />} />
                </a>
            );
        } else {
            return (
                <Button
                    label={<Translate value="help.help" />}
                    onClick={() => {
                        this.props.dispatchOpenWebviewModalWithParams({
                            link: config.HELP_ON_REDLIKE_FILE_TRANSFER,
                            title: translate("help.help")
                        });
                    }}
                />
            );
        }
    };

    getProtocolFolderPath = () => {
        if (windowService.isBrowser()) {
            return (
                <React.Fragment key="folder-path">
                    <div className="col-4">
                        <Translate value="rccDriverSettings.folder" />:
                    </div>
                    <div className="col-8">
                        <Input
                            className="primary-input"
                            value={this.state.protocolFolderPath}
                            onChange={this.handleProtocolFolderPathChange}
                        />
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment key="folder-path">
                <div className="col-4">
                    <Translate value="rccDriverSettings.folder" />:
                </div>
                <div className="col-8 flex flex-column-gap-10px">
                    <Input
                        className="primary-input flex-child fill-flex-space"
                        value={this.state.protocolFolderPath}
                        readOnly={true}
                    />
                    <Button
                        className="padding-block-none"
                        label={"..."}
                        onClick={this.handleOpenProtocolFolderPathDialogClick}
                    />
                </div>
            </React.Fragment>
        );
    };

    getProtocolHost = () => {
        return (
            <React.Fragment key="host">
                <div className="col-4">
                    <Translate value="rccDriverSettings.host" />:
                </div>
                <Input
                    className="primary-input col-8"
                    value={this.state.protocolHost}
                    onChange={this.handleProtocolHostChange}
                />
            </React.Fragment>
        );
    };

    getProtocolPort = () => {
        return (
            <React.Fragment key="port">
                <div className="col-4">
                    <Translate value="clientServerSettings.port" />:
                </div>
                <Input
                    className="primary-input col-8"
                    value={this.state.protocolPort}
                    onChange={this.handleProtocolPortChange}
                />
            </React.Fragment>
        );
    };

    getProtocolUsername = () => {
        return (
            <React.Fragment key="username">
                <div className="col-4">
                    <Translate value="login.username" />:
                </div>
                <Input
                    className="primary-input col-8"
                    value={this.state.protocolUsername}
                    onChange={this.handleProtocolUsernameChange}
                />
            </React.Fragment>
        );
    };

    getProtocolPassword = () => {
        return (
            <React.Fragment key="password">
                <div className="col-4">
                    <Translate value="login.password" />:
                </div>
                <Input
                    className="primary-input col-8"
                    value={this.state.protocolPassword}
                    onChange={this.handleProtocolPasswordChange}
                />
            </React.Fragment>
        );
    };

    getProtocolRemoteFolder = () => {
        return (
            <React.Fragment key="remote-folder">
                <div className="col-4">
                    <Translate value="fileTransfer.remoteFolder" />:
                </div>
                <Input
                    className="primary-input col-8"
                    value={this.state.protocolRemoteFolder}
                    onChange={this.handleProtocolRemoteFolderChange}
                />
            </React.Fragment>
        );
    };

    getProtocolDirectionSelectBox = () => {
        return (
            <React.Fragment key="direction">
                <div className="col-4">
                    <Translate value="fileTransfer.direction" />:
                </div>
                <select
                    className="primary-select col-8"
                    value={this.state.protocolDirection}
                    onChange={this.handleProtocolDirectionChange}
                >
                    <option value={settings.OPTION_NONE}>-</option>
                    <option value="in">{translate("general.in")}</option>
                    <option value="out">{translate("general.out")}</option>
                </select>
            </React.Fragment>
        );
    };

    getIntervalElement = () => {
        if (this.state.type === settings.FILE_TRANSFER_OUT_TASK) {
            return null;
        }

        return (
            <React.Fragment>
                <div className="col-4">
                    <Translate value="general.interval" />:
                </div>
                <div className="col-8 flex flex-column-gap-10px">
                    <Input
                        className="primary-input col-4 flex-child"
                        labelAfter={<Translate value="general.hours" />}
                        value={this.state.intervalHours}
                        onChange={this.handleIntervalHoursChange}
                    />
                    <Input
                        className="primary-input col-4 flex-child"
                        labelAfter={<Translate value="general.minutes" />}
                        value={this.state.intervalMinutes}
                        onChange={this.handleIntervalMinutesChange}
                    />
                    <Input
                        className="primary-input col-4 flex-child"
                        labelAfter={<Translate value="general.seconds" />}
                        value={this.state.intervalSeconds}
                        onChange={this.handleIntervalSecondsChange}
                    />
                </div>
            </React.Fragment>
        );
    };

    getProtocolElements = () => {
        let protocolElements = [];

        for (let option of this.state.protocolOptions) {
            switch (option.key) {
                case "folder_path":
                    protocolElements.push(this.getProtocolFolderPath());
                    break;
                case "host":
                    protocolElements.push(this.getProtocolHost());
                    break;
                case "port":
                    protocolElements.push(this.getProtocolPort());
                    break;
                case "username":
                    protocolElements.push(this.getProtocolUsername());
                    break;
                case "password":
                    protocolElements.push(this.getProtocolPassword());
                    break;
                case "folder":
                    protocolElements.push(this.getProtocolRemoteFolder());
                    break;
                case "direction":
                    protocolElements.push(this.getProtocolDirectionSelectBox());
                    break;
                default:
                    break;
            }
        }

        return protocolElements;
    };

    getNotificationElement = () => {
        if (this.state.type !== settings.FILE_TRANSFER_IN_TASK) {
            return null;
        }

        return (
            <React.Fragment>
                <div className="col-4">
                    <Translate value="fileTransfer.afterImport" />:
                </div>
                <div className="col-8">
                    <div className="col-12 no-padding">
                        <label className="radio-style light-style">
                            <input
                                className="radio"
                                type="radio"
                                name="notification"
                                value={settings.NOTIFICATION_DIALOG}
                                checked={this.state.notification === settings.NOTIFICATION_DIALOG}
                                onChange={this.handleNotificationChange}
                            />
                            <span className="checkmark" />
                            <Translate value="fileTransfer.statusbar" />
                        </label>
                    </div>
                    <div className="col-12 no-padding">
                        <label className="radio-style light-style">
                            <input
                                className="radio"
                                type="radio"
                                name="notification"
                                value={settings.NOTIFICATION_FLASH_MESSAGE}
                                checked={this.state.notification === settings.NOTIFICATION_FLASH_MESSAGE}
                                onChange={this.handleNotificationChange}
                            />
                            <span className="checkmark" />
                            <Translate value="fileTransfer.flashMessage" />
                        </label>
                    </div>
                    <div className="col-12 no-padding">
                        <label className="radio-style light-style">
                            <input
                                className="radio"
                                type="radio"
                                name="notification"
                                value={settings.OPTION_NONE}
                                checked={this.state.notification === settings.OPTION_NONE}
                                onChange={this.handleNotificationChange}
                            />
                            <span className="checkmark" />
                            <Translate value="fileTransfer.noInformation" />
                        </label>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    getStartTypeElement = () => {
        if (this.state.type !== settings.FILE_TRANSFER_OUT_TASK) {
            return null;
        }

        return (
            <React.Fragment>
                <div className="col-4">
                    <Translate value="fileTransfer.startType" />:
                </div>
                <div className="col-8">
                    <label className="radio-style light-style">
                        <input
                            className="radio"
                            type="radio"
                            name="startType"
                            value={settings.START_TYPE_AUTO}
                            checked={this.state.startType === settings.START_TYPE_AUTO}
                            onChange={this.handleStartTypeChange}
                        />
                        <span className="checkmark" />
                        <Translate value="general.automatically" />
                    </label>
                </div>
            </React.Fragment>
        );
    };

    getModalTitle = () => {
        if (this.state.type === settings.FILE_TRANSFER_OUT_TASK) {
            return <Translate value="fileTransfer.exportTask" />;
        }

        return <Translate value="fileTransfer.importTask" />;
    };

    getWarningMessage = () => {
        if (this.state.alreadyExists) {
            return (
                <div className="alert alert-warning col-12">
                    <Translate value="fileTransfer.alreadyExists" />
                </div>
            );
        }

        return null;
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getWarningMessage()}
                <div className="col-4">
                    <Translate value="general.nameTitle" />:
                </div>
                <Input className="col-8 primary-input" value={this.state.name} onChange={this.handleNameChange} />
                <div className="col-4">
                    <Translate value="general.type" />:
                </div>
                <select
                    className="col-8 primary-select"
                    value={this.state.protocol}
                    onChange={this.handleProtocolChange}
                >
                    {this.getProtocolSelectBox()}
                </select>
                <div className="col-4">
                    <Translate value="importData.format" />:
                </div>
                <select className="col-8 primary-select" value={this.state.format} onChange={this.handleFormatChange}>
                    {this.getFormatSelectBox()}
                </select>
                {this.getIntervalElement()}
                {this.getProtocolElements()}
                {this.getNotificationElement()}
                {this.getStartTypeElement()}
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll font-1_5vh"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getHelpButton()}
                {this.state.protocol !== settings.OPTION_NONE && this.state.protocol !== settings.PROTOCOL_FOLDER && (
                    <Button
                        label={<Translate value="fileTransfer.testConnection" />}
                        onClick={this.handleTestConnectionClick}
                        disabled={!this.state.isValid || this.props.loading}
                    />
                )}
                <Button
                    className="margin-left-auto"
                    label={<Translate value="general.confirm" />}
                    svgBefore={imgConfirm}
                    onClick={this.handleConfirmClick}
                    disabled={!this.state.isValid || this.state.alreadyExists}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                header={modelHelper.buildModalSection(this.getModalTitle())}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        taskInList: store.settings.fileTransferInTasks,
        taskOutList: store.settings.fileTransferOutTasks,
        protocolList: store.global.protocolList,
        inFormatList: store.global.inFormatList,
        outFormatList: store.global.outFormatList,
        softwareName: store.settings.softwareName,
        loading: store.server.requests.some((request) => request.method === handlers.TEST_PROTOCOL)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.FILE_TRANSFER_TASK_MODAL));
        },
        dispatchSetFileTransferInTasksAction: (tasks) => {
            dispatch(settingsActions.setFileTransferInTasks(tasks));
        },
        dispatchSetFileTransferOutTasksAction: (tasks) => {
            dispatch(settingsActions.setFileTransferOutTasks(tasks));
        },
        dispatchOpenWebviewModalWithParams: (params) => {
            dispatch(
                navigationActions.openModalWithParams(componentTypes.MODAL_NO_TAB, componentTypes.WEBVIEW_MODAL, params)
            );
        },
        dispatchTestProtocolConnectionAction: (protocol, protocolOptions) => {
            dispatch(globalActions.testProtocolConnection(protocol, protocolOptions));
        }
    };
};

export default FileTransferTaskModal = connect(mapStoreToProps, mapDispatchToProps)(FileTransferTaskModal);
